export default __webpack_public_path__ + "static/media/arrow-down.68bc9d9a.svg";